var vm = new Vue({
    el: "#YI",
    data: {
        websiteInfo: Y.websiteInfo,
        menuActive: false,
        data: {
            detail: [
                {
                    content: "",
                    topic: ""
                },
                {
                    content: "",
                    topic: ""
                },
                {
                    content: "",
                    topic: ""
                }
            ],
            resume: ""
        }
    },
    mounted: function() {
        var that = this;
        document.addEventListener("scroll", function() {
            //that.scrollTop = window.scrollY;
        });
        window.addEventListener("touchmove", function(event) {
            //that.scrollTop = window.scrollY;
        });
        this.getInfo();
    },
    methods: {
        goto: function(id) {
            var offsetTop = document.querySelector("#" + id).offsetTop;
            window.scrollTo({
                top: offsetTop - 50,
                behavior: "smooth"
            });
        },
        getInfo: function() {
            var that = this;
            Y.Axios.get(G.Api + "/home/company/info").then(function(reply) {
                if (reply.code === 200) {
                    that.data = reply.data;
                }
            });
        },
        toggleMenu: function() {
            this.menuActive = !this.menuActive;
        }
    }
});
